import type { ServiceId } from '../types/copy';

export const images = {
  hero: 'https://imgur.com/5olFQHr.jpg',
  concept:
    'https://imgur.com/pp8f0zJ.jpg',
  instructor: 'https://cdn.magicpatterns.com/uploads/15eqxakj2PtkLKU6HVb1rs/IMG_Bio.jpg',
  logo: 'https://cdn.magicpatterns.com/uploads/39FPYuToEzP1KCezYHZkcG/almayoga_sin_fondo.png',
};

// Pages of the Beyond the Lobby feature, in reading order.
// `focus` is the crop used for card thumbnails.
export const pressPages = [
  { src: 'https://cdn.magicpatterns.com/uploads/fXT7TLaJw5cFvLubgbWCsR/Prensa1.jpg', focus: '50% 0%' },
  { src: 'https://cdn.magicpatterns.com/uploads/6UuzE2AsJqGVLQQPD7WUGq/Prensa2.jpg', focus: '50% 85%' },
  { src: 'https://cdn.magicpatterns.com/uploads/oN4Wkvi8J81hXraUuBWTcQ/Prensa3.jpg', focus: '50% 78%' },
  { src: 'https://cdn.magicpatterns.com/uploads/o4h7Ra41sATE9R6TGqKqkY/Prensa4.jpg', focus: '50% 85%' },
];

export const serviceImages: Record<ServiceId, string> = {
  'in-home':
    'https://imgur.com/rSuHQrD.jpg',
  online:
    'https://imgur.com/AXN8Dqt.jpg',
  athletes:
    'https://imgur.com/RVfOvad.jpg',
  travelers:
    'https://imgur.com/PhU9Rxb.jpg',
  astrology:
    'https://cdn.magicpatterns.com/patterns/generated-images/f4aacf76-57e6-428a-91b6-abf9aa2bc0fd.jpg',
  groups:
    'https://cdn.magicpatterns.com/patterns/generated-images/138ef95f-ea84-420d-99f5-e11dba7b687b.jpg',
};
